import { Component, OnInit } from '@angular/core';
import {BaseComponent} from './shared/core/base.component'
import {AuthenticationService} from './services/authentication.service'
@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html'
})

export class AppComponent extends BaseComponent implements OnInit {
  constructor( authenticationService:AuthenticationService) {
    super(authenticationService);
  }

    ngOnInit() {
    
    }
}
